// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-biz-select-kng-drawer .yxt-drawer__body{padding:24px 24px 0}", ""]);
// Exports
module.exports = exports;
